import { loggerUtil } from '@cmg/common';
import {
  Box,
  Button,
  Divider,
  PageHeader,
  PageLayout,
  SnackbarManager,
  Stack,
} from '@cmg/design-system';
import { Form, FormikProvider, useFormik } from 'formik';
import React from 'react';

import RegionsSettings from './RegionsSettings';
import { useStoredUserSettings } from './storedUserSettings';

const SettingsRoute: React.FC = () => {
  const [storedSettings, setStoredSettings] = useStoredUserSettings();
  const { log } = loggerUtil.useMixpanel();
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: storedSettings,
    onSubmit: values => {
      setStoredSettings(values);
      SnackbarManager.success('Settings Saved.');
      log('User Settings: Region saved', {
        locale: values.locale,
        previousLocale: storedSettings.locale,
      });
    },
  });

  return (
    <Stack flex={1} height="100%">
      <PageLayout
        flex={1}
        header={
          <React.Fragment>
            <Divider />
            <PageHeader
              pageTitle={
                <Stack direction="row" alignItems="center">
                  Settings
                </Stack>
              }
            />
            <Divider />
            <Stack margin={3} gap={2}>
              <FormikProvider value={formik}>
                <Form>
                  <RegionsSettings value={formik.values.locale} onChange={formik.handleChange} />
                </Form>
              </FormikProvider>
              <Box>
                <Button onClick={() => formik.handleSubmit()} variant="contained" color="primary">
                  Save
                </Button>
              </Box>
            </Stack>
          </React.Fragment>
        }
      />
    </Stack>
  );
};

export default SettingsRoute;
